import React from "react";
import {expertiseStatusCell} from "./Cell/ExpertiseStatus"
import {skillCell} from "./Cell/Skill";
import {specialityCell} from "./Cell/Speciality";
import {programCell, programGroupingCell} from "./Cell/Program";
import {localDateCell} from "./Cell/LocalDate";
import {nameListCell} from "./Cell/NameList";
import {roleListCell} from "./Cell/RoleList";
import {phoneCell} from "./Cell/Phone";
import {groupStateCell} from "./Cell/GroupState";
import {planStateCell} from "./Cell/PlanState";
import {personCell} from "./Cell/PersonName";
import {contactsCell} from "./Cell/Contacts";
import {groupPlanCell} from "./Cell/GroupPlan";
import {requestStateCell} from "./Cell/RequestProgramStatus";
import {organizationListCell} from "./Cell/OrganizationList";
import {personRegStatusCell} from "./Cell/PersonStatus";
import {masterClassStateCell} from "./Cell/MasterClassStatus";
import {requestSimilarCountCell} from "./Cell/RequestProgramSimilar";
import {coordinatesCell} from "./Cell/Coordinates";

function dispatchCellType(columnSpec) {
  let qType = columnSpec.qType;
  let config = {};
  if (qType === "ExpertiseStatus") {
    expertiseStatusCell(config, columnSpec);
  } else if (qType === "Skill") {
    skillCell(config, columnSpec);
  } else if (qType === "Speciality") {
    specialityCell(config, columnSpec);
  } else if (qType === "Program") {
    programCell(config, columnSpec);
  } else if (qType === "ProgramGrouping") {
    programGroupingCell(config, columnSpec);
  } else if (qType === "LocalDate") {
    localDateCell(config, columnSpec);
  } else if (qType === "NameList") {
    nameListCell(config, columnSpec);
  } else if (qType === "RoleList") {
    roleListCell(config, columnSpec);
  } else if (qType === "OrganizationList") {
    organizationListCell(config, columnSpec);
  } else if (qType === "Phone") {
    phoneCell(config, columnSpec);
  } else if (qType === "GroupState") {
    groupStateCell(config, columnSpec);
  } else if (qType === "PlanState") {
    planStateCell(config, columnSpec);
  } else if (qType === "Person") {
    personCell(config, columnSpec);
  } else if (qType === "Contacts") {
    contactsCell(config, columnSpec);
  } else if (qType === "ProgramPlanCheck") {
    groupPlanCell(config, columnSpec);
  } else if (qType === "RequestProgramStatus") {
    requestStateCell(config, columnSpec);
  } else if (qType === "PersonState") {
    personRegStatusCell(config, columnSpec);
  } else if (qType === "MasterClassState") {
    masterClassStateCell(config, columnSpec);
  } else if (qType === "RequestProgramSimilar") {
    requestSimilarCountCell(config, columnSpec)
  } else if (qType === "Coordinates") {
    coordinatesCell(config, columnSpec)
  }
  return config;
}

function customizeColumns(columns) {
  let clientColumns = [];

  for (let idx = 0; idx < columns.length; idx++) {
    let columnSpec = columns[idx];
    let clientColumn = {
      ...columnSpec,
      ...dispatchCellType(columnSpec)
    };
    if (columnSpec.columns && columnSpec.columns.length > 0) {
      clientColumn.columns = customizeColumns(columnSpec.columns)
    }
    clientColumns.push(clientColumn);
  }
  return clientColumns;
}

export default customizeColumns;
